<template>
    <div class="items-container">
        <div class="itmes-row">
            <div class="item-title">
                자이스 스마일
            </div>
            <div class="item-number">
                {{ formatCommaNumber(smileCount) }} 건
            </div>
        </div>
        <div class="itmes-row">
            <div class="item-title">
                자이스 스마일 프로
            </div>
            <div class="item-number">
                {{ formatCommaNumber(smileProCount) }} 건
            </div>
        </div>
    </div>
</template>
<script>
import {
  formatCommaNumber,
  oneBtnDialog,
} from "@/utils/utils";
import dayjs from "dayjs";
import 'dayjs/locale/ko'
export default {
    components: {
    },
    props: {
        smileCount: Number,
        smileProCount: Number,
    },
    watch: {
    },
    data() {
        return {
        }
    },
    async mounted() {
    },
    methods: {
        formatCommaNumber,
    }
}
</script>
<style lang="scss">
</style>
<style scoped lang="scss">
$Gray-5: #D1D6DB;
$Gray-10: #F1F2F3;
$Gray-20: #e8ebed;
$Gray-50: #ACB2B9;
$Gray-60: #8D939A;
$Gray-70: #6e747c;
$Gray-80: #4B5158;
$Gray-90: #2F3337;
$Gray-100 : #17191C;
$Yellow: #ffe414;
$SkyBlue : #E1F0FF;
$Blue : #278AEC;
$Red: #F55247;
$Pink: #F8948E;
$LightPink: #F7D7D4;
$Orange: #FFA50A;
$Green: #22BF22;

.items-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    .itmes-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 8px;
        .item-title {
            font-size: 12px;
            font-weight: 400;
            color: $Gray-60;
            min-width: 60px;
        }
        .item-number {
            min-width: 70px;
            border: 1px solid $Red;
            background-color: $LightPink;
            border-radius: 4px;
            padding: 2px 4px;
            color: $Red;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
</style>